module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ken Jennings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ken Jennings is the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('I', [_vm._v("Brainiac")]), _vm._v(", "), _c('I', [_vm._v("Maphead")]), _vm._v(", "), _c('I', [_vm._v("Because I Said So!")]), _vm._v(", and "), _c('I', [_vm._v("Planet Funny")]), _vm._v(". In 2020, he won the “Greatest of All Time” title on the quiz show "), _c('I', [_vm._v("Jeopardy!")]), _vm._v(" and in 2022, he succeeded Alex Trebek as a host of the show. He is living in Seattle during his mortal sojourn, but his posthumous whereabouts are still to be determined.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cLZZVc/tc-custom/9781451656275.jpg?1730520794621",
      "alt": "This image is the cover for the book Because I Said So!"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Because I Said So!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("Jeopardy!")]), _vm._v(" champion & host uses scientific research to determine the truth behind 125 common parental edicts in this "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestseller.")]), _c('br'), _c('br'), _vm._v("Is any of it true? If so, how true? Ken Jennings wants to find out if parents always know best. Yes, all those years you were told not to sit too close to the television or swallow your gum or crack your knuckles are called into question by our country’s leading trivia guru. Jennings separates myth from fact to debunk a wide variety of parental edicts: no swimming after meals, sit up straight, don’t talk to strangers, and so on."), _c('br'), _c('br'), _vm._v("Armed with medical case histories, scientific findings, and even the occasional experiment on himself (or his kids), Jennings exposes countless examples of parental wisdom run amok. Whether you’re a parent plagued by needless concern or a kid (of any age) looking to say, “I told you so,” this is the anti–helicopter parenting book you’ve been waiting for.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scribner\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0